/* ─────────────────────────────────────────────────────────────────────────────
   ЧИПЫ ТИПА ИМУЩЕСТВА.

   Раньше тип выбирали выпадающим списком, и он почти не работал: страница
   передавала в фильтр имя раздела («house»), а фильтр ждал свой ключ
   («houses»), поэтому список молча возвращался целиком. Здесь ключи сведены
   в одном месте, а сам выбор стал чипами — все варианты видно сразу.

   У транспорта список автосалонов собираем из самих лотов: в конфиге сервера
   заведён один салон, а в продаже бывают машины из всех.
   ───────────────────────────────────────────────────────────────────────────── */
import { BUSINESS_TYPES, PROPERTY_TYPES, ITEM_TYPES, CLOTHES_TYPES } from './configs/sort'
import { filterItems } from './modules/filter'

const fromConfig = (config) => Object.entries (config).map (([id, value]) => ({ id, name: value.label }));

const AUCTION_TYPES = [
    { id: "vehicle",  name: "Транспорт" },
    { id: "house",    name: "Недвижимость" },
    { id: "business", name: "Бизнес" },
    { id: "item",     name: "Предметы" },
];

export const chipsOf = (category, items) => {
    switch (category) {
        case "auction":
            return { label: "Тип", list: AUCTION_TYPES.filter ((t) => items.some ((x) => x.type == t.id)) };

        case "vehicle": {
            const shows = [];
            items.forEach ((x) => {
                const show = x.params && x.params.motorShow;
                if (show && !shows.includes (show)) shows.push (show);
            });
            return { label: "Автосалон", list: shows.map ((s) => ({ id: s, name: s })) };
        }

        case "house":    return { label: "Тип",       list: fromConfig (PROPERTY_TYPES) };
        case "business": return { label: "Вид",       list: fromConfig (BUSINESS_TYPES) };
        case "item":     return { label: "Категория", list: fromConfig (ITEM_TYPES) };
        case "clothes":  return { label: "Тип вещи",  list: fromConfig (CLOTHES_TYPES) };
    }

    return { label: "", list: [] };
};

export const applySub = (list, category, sub) => {
    if (sub == null)
        return list;

    switch (category) {
        case "auction":  return filterItems (list, "categories", sub);
        case "vehicle":  return list.filter ((x) => x.params && x.params.motorShow == sub);
        case "house":    return filterItems (list, "houses", sub);
        case "business": return filterItems (list, "businesses", sub);
        case "item":     return filterItems (list, "item", sub);
        case "clothes":  return filterItems (list, "clothes", sub);
    }

    return list;
};
